<template>
  <ankh-list v-bind="$attrs" :show-btn-group="false">
    <template #search-form>
      <el-form-item :label="$t('订单号')">
        <el-input :placeholder="$t('订单号')" clearable v-model="searchForm.num" />
      </el-form-item>

      <el-form-item :label="$t('用户昵称')">
        <el-input :placeholder="$t('用户昵称')" clearable v-model="searchForm.username" />
      </el-form-item>
      <el-form-item :label="$t('内容')">
        <dict-select clearable v-model="searchForm.orderType" flag="ORDER_TYPE" />
      </el-form-item>
      <el-form-item :label="$t('交易类型')">
        <dict-select clearable v-model="searchForm.type" flag="DEAL_TYPE" />
      </el-form-item>
      <el-form-item :label="$t('交易状态')">
        <dict-select clearable v-model="searchForm.status" flag="ORDER_STATUS" />
      </el-form-item>
      <el-form-item :label="$t('交易方式')">
        <dict-select clearable v-model="searchForm.payType" flag="PAY_TYPE" />
      </el-form-item>
      <el-form-item :label="$t('交易时间')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          :request-params="{searchType: 'user'}"
          :search-params="searchForm"
          :data="tableData"
          @query="handleSearch">
        <el-table-column :label="$t('订单号')" prop="num" fixed />
        <el-table-column :label="$t('交易类型')" fixed>
          <template v-slot="{row}">
            <dict-text :status="row.type" dict-flag="DEAL_TYPE" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('内容')">
          <template v-slot="{row}">
            <dict-text :status="row.orderType" dict-flag="ORDER_TYPE" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('用户编号')" prop="userNum" />
        <el-table-column :label="$t('用户昵称')" prop="username" />
        <el-table-column :label="$t('金额')" prop="price">
          <template v-slot="{row}">
            {{row.price | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('交易方式')" prop="payType">
          <template v-slot="{row}">
            <dict-text :status="row.payType" dict-flag="PAY_TYPE" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('交易状态')" prop="status">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="ORDER_STATUS" />

          </template>
        </el-table-column>
        <el-table-column :label="$t('交易时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('余额')" prop="balance">
          <template v-slot="{row}">
            {{row.balance | formatPrice}}
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import DictText from "@/components/dict/DictText.vue";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker.vue";
import DictSelect from "@/components/dict/DictSelect.vue";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserOrder",
  components: {AnkhList, DictSelect, DateTimeRangePicker, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: []
    }
  },
  methods: {
    // 加载数据
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.anOrder.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
